import axios from 'axios';
import { message } from 'antd';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.bjr8888.com/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 60000, // 延長到 60 秒，以支持級聯刪除等複雜操作
  headers: {
    'Content-Type': 'application/json',
  },
});

// 請求攔截器
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('agentToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 響應攔截器
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 特殊處理：這些請求不自動顯示錯誤訊息，讓組件自己處理
    const isLoginRequest = error.config?.url?.includes('/agent/auth/login');
    const isCreateObserverRequest = error.config?.url?.includes('/agent/manage/create-observer');
    const isCreateAgentRequest = error.config?.url?.includes('/agent/manage/create-agent');
    const isRemoveAgentRequest = error.config?.url?.includes('/agent/manage/remove-agent');
    const isSuspendAgentRequest = error.config?.url?.includes('/agent/manage/suspend-agent');
    const isActivateAgentRequest = error.config?.url?.includes('/agent/manage/activate-agent');
    const isTransferMemberRequest = error.config?.url?.includes('/agent/manage/transfer-member');
    const isRemoveMemberRequest = error.config?.url?.includes('/agent/manage/remove-member');
    const isCascadeDeleteRequest = error.config?.url?.includes('/agent/manage/cascade-delete');
    const shouldSkipAutoError = isLoginRequest || isCreateObserverRequest || isCreateAgentRequest ||
                                isRemoveAgentRequest || isSuspendAgentRequest || isActivateAgentRequest ||
                                isTransferMemberRequest || isRemoveMemberRequest || isCascadeDeleteRequest;

    if (error.response && !shouldSkipAutoError) {
      switch (error.response.status) {
        case 401:
          // 清除所有 sessionStorage
          sessionStorage.clear();
          // 根據錯誤代碼顯示不同訊息
          const errorCode = error.response.data?.code;
          const errorMessage = error.response.data?.error;

          if (errorCode === 'SESSION_INVALID') {
            // 防止重複觸發
            if (window.__logoutInProgress) {
              return Promise.reject(error);
            }
            window.__logoutInProgress = true;

            // 使用原生 confirm 確保一定能顯示
            const userConfirmed = window.confirm(
              (errorMessage || '您已在其他設備登入') + '\n\n點擊確定跳轉到登入頁面'
            );

            if (userConfirmed) {
              window.location.href = '/login';
            } else {
              // 用戶取消，重置標記
              window.__logoutInProgress = false;
            }
          } else {
            message.error(errorMessage || '認證已過期，請重新登入');
            window.location.href = '/login';
          }
          break;
        case 403:
          message.error('權限不足');
          break;
        case 404:
          message.error('請求的資源不存在');
          break;
        case 500:
          message.error('伺服器錯誤');
          break;
        default:
          message.error(error.response.data.error || '請求失敗');
      }
    } else if (error.request && !shouldSkipAutoError) {
      message.error('網路錯誤，請檢查連線');
    } else if (!shouldSkipAutoError) {
      message.error('請求配置錯誤');
    }
    
    return Promise.reject(error);
  }
);

export default api;